import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { acme, acmeIconTones } from '../../theme/acmeTheme';
import { Card, CardContent } from './Card';
import { mergeSx } from './utils/mergeSx';

/**
 * Dashboard statistics card (Campaigns, Opens, etc.)
 */
export default function StatCard({
  title,
  icon,
  value,
  rate,
  loading,
  selected,
  onClick,
  subtitle = 'Total',
  rateLabel = 'RATE',
  sx,
  children,
}) {
  return (
    <Card
      onClick={onClick}
      sx={mergeSx(
        {
          height: '100%',
          cursor: onClick ? 'pointer' : 'default',
          boxShadow: selected ? acme.shadow.lg : 'none',
          borderColor: selected ? acme.colors.iconEmphasis : acme.colors.border,
          transition: 'transform 0.15s, box-shadow 0.15s, border-color 0.15s',
          '&:hover': onClick
            ? { transform: 'translateY(-2px)', boxShadow: acme.shadow.lg }
            : {},
        },
        sx,
      )}
    >
      <CardContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          p: { xs: 1.5, sm: 2 },
          position: 'relative',
          '&:last-child': { pb: { xs: 1.5, sm: 2 } },
        }}
      >
        {children}
        {icon && (
          <Box
            sx={{
              mb: 1,
              color: acmeIconTones.default,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              lineHeight: 0,
            }}
          >
            {icon}
          </Box>
        )}
        <Typography
          sx={{
            fontSize: '0.6875rem',
            fontWeight: 700,
            letterSpacing: '0.06em',
            color: acme.colors.mutedForegroundSolid,
            textTransform: 'uppercase',
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: '1.75rem', sm: '2.25rem' },
            fontWeight: 700,
            color: acme.colors.foreground,
            my: 0.5,
            lineHeight: 1.1,
          }}
        >
          {loading ? (
            <CircularProgress size={24} sx={{ color: acmeIconTones.default }} />
          ) : (
            value
          )}
        </Typography>
        {subtitle && (
          <Typography sx={{ fontSize: '0.8125rem', color: acme.colors.mutedForegroundSolid }}>
            {subtitle}
          </Typography>
        )}
        {rate > 0 && (
          <Typography
            sx={{ mt: 0.5, fontSize: '0.75rem', fontWeight: 600, color: acme.colors.iconDefault }}
          >
            {rate}% {rateLabel}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
}
